import * as React from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Typography } from "@material-ui/core";

// CSS
const useStyles = makeStyles((theme) => ({ }));

// All the incoming values
interface IProps {
    title: string;
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch;
export const Title = (props: AllProps) => {
    const classes = useStyles(useTheme());
    return (<Typography variant="h3" gutterBottom>{props.title}</Typography>)
}